<template>
  <div id="app">
    <v-app>
      <status-alert :color="statusColor" :shown.sync="statusShown">
        {{ statusMessage }}
      </status-alert>
      <router-view/>
    </v-app>
  </div>
</template>

<script>
  import Bus from './bus'
  import StatusAlert from './components/StatusAlert'

  export default {
    name: 'App',
    data () {
      return {
        statusMessage: '',
        statusShown: false,
        statusColor: 'error'
      }
    },
    components: {
      StatusAlert
    },
    created () {
      Bus.$on('alert', ({ color, message }) => {
        this.statusShown = true
        this.statusColor = color
        this.statusMessage = message
      })
    },
    mounted () {
      window.addEventListener('resize', this.resizeEvent)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeEvent)
    },
    methods: {
      resizeEvent () {
        Bus.$emit('resize')
      }
    }
  }
</script>
